<template>
  <form class="search" @submit="search">
    <div class="search-wrapper">

      <div class="icon h-i-center">
        <i class="material-icons">
          search
        </i>
      </div>

      <input
        class="h-empty-input"
        :type="type"
        :placeholder="placeholder"
        v-model="s"
      >

      <app-btn
        class="exe"
        v-if="s.length > 0"
        type="submit"
      >
        {{ $ml.get('search') }}
      </app-btn>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    placeholder: {},
    type: {},
  },
  data() {
    return {
      s: '',
    }
  },
  methods: {
    search(e) {
      e.preventDefault();
      if(this.s.length > 0) this.$emit('input', this.s);

    }
  },
  watch: {
    s(val) {
      if (val == '') this.$emit('input', val);
    }
  }

}
</script>

<style lang="scss" scoped>
.search {
  padding: 5px;
  // margin-top: 4px;
  // margin-bottom: 4px;
  // height: 40px;
  width: 100%;
  position: relative;

  // overflow: hidden;
  // border-bottom: 1px solid rgba(76, 80, 86, 0.10);

  .search-wrapper {
    background: #F3F3F3;
    border-radius: 5px;
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 8px;
    .icon {
      // position: absolute;
      // left: 8px;
      width: 30px;
      // top: 0;
      min-width: 30px;
      height: 100%;
      color: #8B8D91;
    }

    input {
      padding: 10px 10px;
      box-sizing: border-box;
      min-width: 150px;
      flex-grow: 1;
      &::placeholder {
        color: #8B8D91;
        font-size: 14px;
      }
    }

    .exe {
      height: 28px;
      min-height: 28px;
      min-width: 60px;
      font-size: 12px;
      display: flex;
    }
  }
}
</style>
